"use client";

import { IconPlayer } from '@/lib/definitions';
import { cn } from '@/lib/utils';
import { IPlayerOptions } from '@lordicon/react/dist/interfaces';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

//import { Player } from '@lordicon/react';
const Player = dynamic(() => import('@lordicon/react').then(mod => ({ "default": mod.Player })), {
    ssr: false,
    loading: () => <IconSkeleton />
});

export default function AnimatedIcon(props: Omit<IPlayerOptions, "size"> & {
    fill?: boolean,
    size?: number | string,
    className?: string,
    icon: string,
    play?: boolean,
    noHover?: boolean,
    loop?: boolean
}) {
    const { fill, size = "1em", className, icon, play, noHover } = props;

    const [ICON, setICON] = useState<Object | null>(null);
    const [player, setPlayer] = useState<IconPlayer | null>(null); //load player using ref CB
    const [clientLoaded, setClientLoaded] = useState(false);

    //load icon on load
    useEffect(() => {
        setClientLoaded(true);
        const controller = new AbortController()
        if (icon && !ICON) {
            fetch(`/icons/${icon}.json`, { "next": { "revalidate": 60 * 60 * 8 }, "signal": controller.signal })
                .then(res => res.json())
                .then(json => setICON(json))
                .catch(error => {
                    //if cancel by abort - ignore
                    if (error.canceled)
                        return;
                    console.error(error)
                    throw new Error("Invalid icon provided for <AnimatedIcon/> please make sure you have a matching icon's config file at: @/public/icons/")
                });
        }

        return () => {
            controller.abort({ canceled: true }); //abort request if component dismount
        }
    }, [icon, ICON]);

    //autoplay when play attribute changes
    useEffect(() => {
        player && play && ICON && player?.playFromBeginning()
    }, [player, play, ICON])


    function MouseEnter() {
        if (!noHover && player && !player?.isPlaying) {
            player?.playFromBeginning();
        }
    }

    function handleAnimationEnd() {
        if (props.loop)
            player?.playFromBeginning();
    }

    return (
        <>
            { fill && <div onMouseEnter={ MouseEnter } className={ `absolute inset-0 z-10` } /> }
            <div onMouseEnter={ !fill && MouseEnter || (() => { }) }
                className={ cn([`w-1em aspect-square align-middle inline-flex items-center group-hover:hue-rotate-90 group-active:saturate-0 group-active:brightness-150`, className]) }>
                { clientLoaded && <Player
                    { ...props }
                    // @ts-ignore: size can except css size units which count as string
                    size={ size }
                    renderMode="HARDWARE"
                    icon={ ICON }
                    // @ts-ignore: ref does defined at <Player/> BUT from some reason if you dynamic import it - it wont recognize it
                    ref={ setPlayer }
                    onComplete={ handleAnimationEnd }
                />
                    || <IconSkeleton /> }
            </div>
        </>
    );
}

function IconSkeleton() {
    return <div className={ `w-1em aspect-square bg-gradient-to-br from-nfPurple-300/30 to-nfBlue-500/30 block rounded m-auto animate-[pulse_1.5s_ease-in-out_infinite_alternate] ` }>
    </div>;
}